

export default {
  name: "data",
  nickname: "数据",
  desc:
    '图例的数据数组。数组项通常为一个字符串，每一项代表一个系列的 <code class="codespan">name</code>（如果是<a target="__blank" href="https://echarts.apache.org/zh/option.html#series-pie">饼图</a>，也可以是饼图单个数据的 <code class="codespan">name</code>）。图例组件会自动根据对应系列的图形标记（symbol）来绘制自己的颜色和标记，特殊字符串 <code class="codespan">&#39;&#39;</code>（空字符串）或者 <code class="codespan">&#39;\\n&#39;</code>（换行字符串）用于图例的换行。',
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '图例项的名称，应等于某系列的<code class="codespan">name</code>值（如果是饼图，也可以是饼图单个数据的 <code class="codespan">name</code>）。',
    },
    icon: {
      name: "icon",
      nickname: "图表",
      desc: "图例项的 icon。",
    },
    textStyle: {
      name: "textStyle",
      nickname: "文本样式",
      desc: "图例项的文本样式。",
    },
  },
}
